import { useMutation } from "react-query";
import actionService from "../../services/actionService";

const useCalculateFormActions = () =>
  useMutation(actionService.calculateActions);

export default useCalculateFormActions;
